module.exports = __webpack_public_path__ + "static/media-jali-304d0a9bbb7df9bd99687ecdbcc798fa.png";